import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface VideoDialogProps {
  videoUrl: string;
  open: boolean;
  onClose: () => void;
  captionUrl: string | undefined;
}

const VideoDialog: React.FC<VideoDialogProps> = ({
  videoUrl,
  open,
  onClose,
  captionUrl,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogContent
        sx={{
          padding: "0px !important",
          background: "#000",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        <video
          controls
          style={{
            maxWidth: "80vw",
            maxHeight: "80vh",
            width: "auto",
            height: "auto",
            display: "block",
          }}
        >
          <source src={videoUrl} type="video/mp4" />
          {captionUrl && (
            <track
              src={captionUrl}
              kind="subtitles"
              srcLang="en"
              label="English"
              default
            />
          )}
          Your browser does not support the video tag.
        </video>
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
